"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataPoint_1 = require("../utility/DataPoint");
var DataInterfaces_1 = require("../Types/DataInterfaces");
function reduceRetirementData(engineResponse, pregenResponse, requestValues) {
    var currentAge = requestValues.currentAge, targetAge = requestValues.targetAge, currentBalance = requestValues.currentBalance, annualWithdrawal = requestValues.annualWithdrawal, additionalComparison = requestValues.additionalComparison;
    var graphData = [];
    var scenarioData = [];
    //format protobuf data into something thats easier to work with
    engineResponse.forEach(function (datapoint, index) {
        var arr = datapoint.array;
        var dPoint = new DataPoint_1.default(arr[0], arr[1], arr[3], arr[4], arr[5]); //0 = operatorId, 1 = queryId, 3 = timestep, 4 = percentile ,5 = value
        dPoint.metric === "Graph" ? graphData.push(dPoint) : scenarioData.push(dPoint);
    });
    var _a = pregenResponse.array, safeWithdrawalValues = _a[0], whatIfFactors = _a[1];
    var optimizationValues = formatPreGenDataPointArray(safeWithdrawalValues);
    var fumValues = formatPreGenDataPointArray(whatIfFactors);
    //end formatting --^^^
    var dataReducer = require('../utility/DataReducer');
    var reducedMatrixData = dataReducer.reduceData(scenarioData, (targetAge - currentAge), currentBalance, annualWithdrawal, fumValues, optimizationValues);
    var reducedGraphData = dataReducer.generateGraphPoints(graphData);
    var newState = { matrixOutput: reducedMatrixData, graphOutput: reducedGraphData, AssetAllocationInRequest: additionalComparison }; //AssetAllocation to column map was here but I don't know why?
    return newState;
}
exports.reduceRetirementData = reduceRetirementData;
function reduceBacktestData(backtestResponse, inputValues) {
    var backTestData = [];
    backtestResponse.forEach(function (datapoint) {
        var arr = datapoint.array;
        var dPoint = new DataPoint_1.default(arr[0], arr[1], arr[3], arr[4], arr[5]);
        backTestData.push(dPoint);
    });
    var dataReducer = require('../utility/DataReducer');
    var reducedBacktestData = dataReducer.reduceBackTestData(backTestData);
    var newState = { backtestOutput: reducedBacktestData, AssetAllocationInRequest: inputValues.additionalComparison };
    return newState;
}
exports.reduceBacktestData = reduceBacktestData;
function formatPreGenDataPointArray(datapointArr) {
    var temp = {};
    datapointArr.forEach(function (point) {
        //TODO: Delimiter might change, watch out for that
        var _a = point[0].split('|'), strategy = _a[0], isEk = _a[1];
        var regexThatMatchesGFC = RegExp("WhatIf");
        var isGfc = regexThatMatchesGFC.test(strategy) ? DataInterfaces_1.gfc.isGfc : DataInterfaces_1.gfc.notGfc;
        var portfolio = "";
        //if there is an Ek section, then the datapoint must be for a risk profile
        if (isEk) {
            portfolio = isEk === "WithEK" ? DataInterfaces_1.PortfolioContext.SS : DataInterfaces_1.PortfolioContext.Equiv;
        }
        else {
            //The . here is to indicate that this datapoint is for asset allocation
            portfolio = DataInterfaces_1.PortfolioContext.Chosen;
        }
        if (!!temp[portfolio]) {
            temp[portfolio][isGfc] = point[1];
        }
        else {
            temp[portfolio] = {};
            temp[portfolio][isGfc] = point[1];
        }
    });
    return temp;
}
//# sourceMappingURL=EngineResponseToReducedData.js.map